import styled from 'styled-components';
import { breakpoints } from 'config/config';
import { BUTTON_STATES } from 'styles/buttonStates';

export const StyledPageBreadcrumbs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: ${({ theme }) => theme.fontText};
  color: ${({ theme }) => theme.black};

  .page-back.ant-btn {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 8px;
    height: auto;
    padding: 5px 12px;
    border-radius: 40px;
    font-family: inherit;
    font-size: 14px;
    line-height: 1.4;
    transition: border-color 0.2s ease-in-out;

    &,
    &${BUTTON_STATES} {
      border: 1px solid ${({ theme }) => theme.tagBorderColor};
      background-color: ${({ theme }) => theme.white};
      color: ${({ theme }) => theme.black};
    }

    &${BUTTON_STATES} {
      border-color: ${({ theme }) => theme.navDark};
    }

    .text {
      display: block;
    }

    span,
    strong {
      font-size: inherit;
    }

    strong {
      font-weight: 600;
    }
  }

  .page-back-icon {
    display: inline-flex;
    flex: none;
    width: 14.33px;
    height: 14.33px;
  }

  .page-breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 11px;
    font-size: 14px;

    a {
      color: ${({ theme }) => theme.black};
      font-size: inherit;
      text-decoration: underline;

      &:hover {
        color: ${({ theme }) => theme.brand02};
      }
    }
  }

  .page-breadcrumb {
    display: inline-flex;
    align-items: center;
    gap: 11px;
    font-size: inherit;
  }

  .page-breadcrumb-separator {
    display: inline-flex;
    flex: none;
    width: 3.35px;
    height: 5.71px;
  }

  .page-back-icon img,
  .page-breadcrumb-separator img {
    display: block;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .page-back.ant-btn,
    .page-breadcrumbs {
      font-size: 0.875rem;
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    gap: 0.75rem;
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .page-breadcrumbs {
      row-gap: 0.375rem;
      column-gap: 0.5rem;
    }

    .page-breadcrumb {
      gap: 0.5rem;
    }
  }
`;
